import { DOMAIN_DETAIL } from "../Types/types";

const intialState = {
  menuList: [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: "grid-dividers.png",
      activeIcon: "grid-dividers-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Jobs",
      path: "/jobs",
      icon: "bag-icon.svg",
      activeIcon: "bag-icon-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Assessments",
      path: "/assessments",
      icon: "shield-trust.svg",
      activeIcon: "shield-trust-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "Gappeo Tests",
      path: "/gappeo-tests",
      icon: "gappeo-test-icon.svg",
      showInDesktop: true,
      showInMobile: false,
    },
    {
      name: "My Tests",
      path: "/my-tests",
      icon: "my-test-icon.svg",
      activeIcon: "my-test-icon-pink.svg",
      showInDesktop: true,
      showInMobile: true,
    },
    {
      name: "My Questions",
      path: "/my-questions",
      icon: "my-questions-icon.svg",
      showInDesktop: true,
      showInMobile: false,
    },
    {
      name: "Reports",
      icon: "analytics.svg",
      showInDesktop: true,
      showInMobile: false,
      subMenu: [
        { name: "Assessments", path: "/reports" },
        { name: "Voice interview", path: "/voice-interviews-report" },
        { name: "Video interview", path: "/video-interviews-report" },
      ]
    },
  ],
  adminMenuList: [
    {
      name: "Assessments",
      icon: "shield-trust.svg",
      subMenu: [
        { name: "My Questions", path: "/my-questions" }
      ]
    },
    {
      name: "Users",
      path: "/users",
      icon: "users.svg",
    }
  ],
};

export default function layoutReducer(state = intialState, action) {
  let stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DOMAIN_DETAIL:
      stateCopy.domainDetails = action.payload;
      localStorage.setItem("domainDetails", JSON.stringify(action.payload));
      return stateCopy;
    default:
      return stateCopy;
  }
}
